import React, { Component } from 'react';
import {c_light, c_background, c_gradient_reds} from '../a-Graphic/Colors';

import getMyMap, {managePopup, createAreasMassLayer, createNamesLayer, createCommuneLayerFlows, createCommuneFlowsLayer, getLegendMode} from '../b-LeafletMap/leaflet_map';

import LegendCommune from '../b-LeafletMap/Legend/LegendCommune';
import LegendClusterArea from '../b-LeafletMap/Legend/LegendClusterArea';
import LegendValuesFlows from '../b-LeafletMap/Legend/LegendValuesFlows';

const L = window.L;

var f_limit = 20;

class WorkFlows extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      legend: {
        intervals : [],
        colors: []}
    };

    this.mode = "ckmeans";
    this.colors = c_gradient_reds;
  }
  componentDidMount() {
    /* COMMUNES */
    var communes = this.props.territory.communes;
    var influence_communes = this.props.territory.influence_communes;
    var work_communes = this.props.territory.work_communes;

    var communes_coords = communes.map((c) => c.center);
    var communes_names = communes.map((c) => c.name);

    var communes_geo_codes_to_coords = {};
    communes.concat(influence_communes).concat(work_communes).map((c) => communes_geo_codes_to_coords[c.geo_code] = c.center)
    var communes_geo_codes_to_names = {};
    communes.concat(influence_communes).concat(work_communes).map((c) => communes_geo_codes_to_names[c.geo_code] = c.name)

    var flows_geocode = communes.map((c) => c.geo_code)
    var flows_coords = communes.map((c) => Object.keys(c.flows_home_work).filter((c_geo)=> c.flows_home_work[c_geo]>f_limit).map((c_geo)=> [c.center, communes_geo_codes_to_coords[c_geo]]))
    var flows_masses = communes.map((c) => Object.values(c.flows_home_work).filter((flow)=> flow>f_limit))
    var flows_labels = communes.map((c) => Object.keys(c.flows_home_work).filter((c_geo)=> c.flows_home_work[c_geo]>f_limit).map((c_geo)=>
                                              c.name + " → " + communes_geo_codes_to_names[c_geo]  + " : " + c.flows_home_work[c_geo].toLocaleString("fr-FR") + " navetteurs"))

    communes.forEach((c, i) => {
      let within_flow = parseInt(c.workers_within_commune_prop * c.status.employed)
      if (within_flow >= 30){
        flows_coords[i].push([c.center, c.center])
        flows_masses[i].push(within_flow)
        flows_labels[i].push(c.name + " → " + c.name  + " : " + within_flow.toLocaleString("fr-FR") + " navetteurs")
      }
    });

    var flows_masses_sum = communes.map((c) => Object.values(c.flows_home_work).reduce((a, b) => a+b, 0) + c.workers_within_commune_prop * c.status.employed);
    var index_main_commune = flows_masses_sum.indexOf(Math.max(...flows_masses_sum))

    var all_flows_masses = flows_masses[0].concat(...flows_masses.slice(1, flows_masses.length))

    /* WORK AREAS */
    var areas_by_reason = this.props.territory.areas_by_reason;
    var work_areas = areas_by_reason.filter((abr)=>abr["name"]=="work")[0]["areas"];
    work_areas = work_areas.filter((wa)=> communes_names.includes(wa.name))
    var work_areas_coords = work_areas.map((a) => a.coords)
    var work_areas_masses = work_areas.map((a) => a.mass)
    var work_areas_labels = work_areas.map((a) => '<span class="small-text">' + a.name + "</span></br>" + a.mass)


    var communes_masses = communes.map((c) => Math.round(work_areas.filter((wa)=>wa.name==c.name)[0].mass/c.status.employed*100));
    var communes_labels = communes.map((c) => c.name + " - " + c.status.employed + " actifs</br>" +
                                              "Ratio emploi/actif.ves : " + Math.round(work_areas.filter((wa)=>wa.name==c.name)[0].mass/c.status.employed*100) + "%");



    // --- init map
    var mymap = this.mymap = getMyMap(this.props.id, true, 0.3);

    var current_flow_layer = index_main_commune;
    let update_flows_layer = (geo_code, flows_layer) => {
      mymap.removeLayer(flows_layer)
      current_flow_layer = flows_geocode.indexOf(geo_code)
      let [legend_intervals, legend_colors] = getLegendMode(this.mode, flows_masses[current_flow_layer], this.colors)
      this.setState({legend: {intervals: legend_intervals, colors: legend_colors}})
      return createCommuneFlowsLayer(mymap, flows_coords[current_flow_layer],
                                            flows_masses[current_flow_layer],
                                            flows_labels[current_flow_layer],
                                            this.mode,
                                            this.colors);
    }

    // --- create layers

    // ---- communes layer
    let communes_g = [];
    for (var i=0; i<communes.length; i++){
      let geo_code = communes[i].geo_code
      for (let o of communes[i].outline){
        let commune = L.polygon(o, {
          color: "#fff",
          fillColor: c_light,
          weight: 1.5,
          opacity: 1,
          fillOpacity: 0.4,
        });
        if(communes_labels!=null){
          managePopup(commune, "<p class='leaflet_map_popup'>" + communes_labels[i] + "</p>", mymap);
        }
        commune.on('click', function (e) {
            mymap.removeLayer(flows_layer)
            flows_layer = update_flows_layer(geo_code, flows_layer);
        });
        commune.on('mouseout', function (e) {
            //flows_layer = createCommuneFlowsLayer(mymap, flows_coords[index_main_commune], flows_masses[index_main_commune], flows_labels[index_main_commune]);
        });
        communes_g.push(commune);
      }
    }
    let communes_layer = L.featureGroup(communes_g);
    communes_layer.addTo(this.mymap);

    console.log(flows_coords)

    var flows_layer = this.flows_layer = createCommuneFlowsLayer(mymap, flows_coords[current_flow_layer],
                                                                        flows_masses[current_flow_layer],
                                                                        flows_labels[current_flow_layer],
                                                                        this.mode,
                                                                        this.colors);

    let [legend_intervals, legend_colors] = getLegendMode(this.mode, flows_masses[current_flow_layer], this.colors)
    this.setState({legend: {intervals: legend_intervals, colors: legend_colors}})
    //var areas_layer = this.areas_layer = createAreasMassLayer(mymap, work_areas_coords, work_areas_masses, work_areas_labels);
    //var names_layer = this.names_layer = createNamesLayer(mymap, communes_coords, communes_names);

    // --- center the map
    mymap.fitBounds(communes_layer.getBounds());
  }


  render() {
    return(
          <div className="row align-items-end">
            <div className="col-10">
              <div style={{height: "500px"}} id={this.props.id}></div>
            </div>
            <div className="col-2 pl-0 pr-0">
                 <p className="mb-5">Cliquer sur une commune pour afficher les flux domicile → travail relatifs à la population active de celle-ci (de plus de {f_limit} navetteurs).</p>
                 <LegendValuesFlows intervals={this.state.legend.intervals} colors={this.state.legend.colors}/>
            </div>
          </div>
    )
  }
}

export default WorkFlows;
